import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3333 4.1665L13.5498 4.1665L14.1667 4.1665L14.1682 4.1665L16.6667 4.1665C17.1269 4.1665 17.5 4.5396 17.5 4.99984C17.5 5.46007 17.1269 5.83317 16.6667 5.83317H15.8333C15.8333 5.87567 15.8317 5.91831 15.8284 5.961L15.0543 16.0249C14.9541 17.3274 13.868 18.3332 12.5616 18.3332H7.43836C6.13202 18.3332 5.04592 17.3274 4.94572 16.0249L4.17158 5.961C4.16829 5.91831 4.16666 5.87567 4.16666 5.83317H3.33333C2.8731 5.83317 2.5 5.46007 2.5 4.99984C2.5 4.5396 2.8731 4.1665 3.33333 4.1665H5.83236L5.83333 4.1665L6.1194 4.1665L6.66667 4.1665C6.66667 2.78579 7.78595 1.6665 9.16667 1.6665H10.8333C12.214 1.6665 13.3333 2.78579 13.3333 4.1665ZM12.4951 5.83317H14.1667L14.0385 7.49984L13.3925 15.8971C13.3591 16.3312 12.9971 16.6665 12.5616 16.6665H10.8333V5.83317H11.6667L12.4951 5.83317ZM9.16667 5.83317H8.33333L7.50492 5.83317L5.83333 5.83317L5.96154 7.49984L6.60748 15.8971C6.64088 16.3312 7.00291 16.6665 7.43836 16.6665H9.16667V5.83317ZM9.16667 4.1665H8.33333C8.33333 3.70627 8.70643 3.33317 9.16667 3.33317L10.8333 3.33317C11.2936 3.33317 11.6667 3.70627 11.6667 4.1665H10.8333L10 4.1665H9.16667Z"
      fill={fill}
    />
  </g>
);

export default Icon;
